<!-- Start Sidemenu Area -->
<div class="sidemenu-area" [class.active]="appservice.isSidebarOpen">
    <div class="sidemenu-header">
        <a class="navbar-brand d-flex align-items-center">
            <img (click)="get_Home()" src="assets/img/logo-rajhair.png" class="sidebar-logo" alt="logo">
        </a>
    </div>

    <div class="sidemenu-body">
        <ul class="sidemenu-nav metisMenu" id="sidemenu-nav" data-simplebar>

            <div *ngFor="let label of appservice.Label_Menu_Rows">

                <li [class.active]="ac == label.ID" class="nav-item">
                    <a href="javascript:void(0)" class="nav-link" (click)="ac = (label.ID == ac) ? 0 : label.ID">
                        <span class="icon"><i class='{{label.Icon}}'></i></span>
                        <span class="menu-title">{{label.Display_Name}}</span>
                    </a>

                    <!-- Sub menu -->
                    <ul class="sidemenu-nav-second-level" *ngIf="ac == label.ID">
                        <li *ngFor="let child of appservice.get_child(label.ID)" class="nav-item sub-item" routerLinkActive="active">
                            <a routerLink="{{child.Route_Link}}" class="nav-link sub-link">
                                <span class="icon"><i class='{{child.Icon}}'></i></span>
                                <span class="menu-title">{{child.Display_Name}}</span>
                            </a>
                        </li>
                    </ul>
                </li>

            </div>

        </ul>
    </div>
</div>
<!-- End Sidemenu Area -->